export const dedupe = <T, K>(arr: T[], keyExtractor: (item: T) => K): T[] => {
  return [...new Map(arr.map((item) => [keyExtractor(item), item])).values()];
};
/**
 * Note this is NOT an in-place operation.
 * @param list
 * @param newItem
 * @param end
 */
export const insertToList = <T>(list: Array<T> | undefined, newItem: T, end?: boolean) => {
  const safeList = list ?? [];
  if (end) {
    return [...safeList, newItem];
  }
  return [newItem, ...safeList];
};

export const insertAllToList = <T>(list: Array<T> | undefined, newItems: T[], end?: boolean) => {
  const safeList = list ?? [];
  if (end) {
    return [...safeList, ...newItems];
  }
  return [...newItems, ...safeList];
};

export const replaceInList = <T>(
  list: T[] | undefined,
  predicate: (oldItem: T) => boolean,
  transform: (oldItem: T) => T
): T[] | undefined => {
  if (!list) {
    return list;
  }
  const index = list.findIndex(predicate);
  if (index >= 0) {
    const left = list.slice(0, index);
    const right = list.slice(index + 1);
    return [...left, transform(list[index]), ...right];
  }
  return list;
};
